export default __webpack_public_path__ + "f880fb1b94e181b7e8550f5657147124.png";